import DataFetch from '../../Utility/data-fetch';
import {default as SiteStorage} from '../../Utility/site-cookies';

const call = (baseUrl) => {
    return {
        currentPassage: {
            translationCode: '',
            bookCode: '',
            chapterId: 0,
            verseId: 0,
        },
        baseUrl: `${baseUrl}`,
        noteReferenceBooks: [],
        noteReferenceDropdownShow: false,
        page: 1,
        itemsPerPage: 5,
        currentPageNotes: [],
        currentViewingBook: null,
        selectedNote: {noteId: -1, private: true},
        showError: false,
        loading: false,
        userNote: {},
        notesIgnoreTranslation: SiteStorage().read('notes-ignore-translation') === 'true',

        async nextPage() {
            if (this.currentPageNotes && this.currentPageNotes.length === this.itemsPerPage) {
                this.page += 1;
            }

            await this.getNotes(this.page, this.itemsPerPage);
        },

        async prevPage() {
            if (this.page > 1) {
                this.page -= 1;
            }

            await this.getNotes(this.page, this.itemsPerPage);
        },

        validateNote() {
            if (!this.selectedNote.labelText || this.selectedNote.labelText.length === 0) {
                return false;
            }

            if (!this.selectedNote.noteText || this.selectedNote.noteText.length === 0) {
                return false;
            }

            return true;
        },

        clearSelected() {
            this.selectedNote = {noteId: -1};
        },

        assignPassage(translationCode, bookCode, chapterId, verseId, endVerseId) {
            this.currentPassage = {
                translationCode: translationCode,
                bookCode: bookCode,
                chapterId: chapterId,
                verseId: verseId,
                endVerseId: endVerseId,
            };
        },

        async getNotes(page, itemsPerPage) {
            this.loading = true;
            this.currentPageNotes = [];

            await DataFetch.get(`${this.baseUrl}references-by-book`,
                {params: {translationCode: this.currentPassage.translationCode}})
                .then((r) => {
                    this.noteReferenceBooks = r.data;
                });

            await DataFetch.get(this.baseUrl,
                this.currentViewingBook ?
                    {
                        params: {
                            page: page,
                            itemsPerPage: itemsPerPage,
                            translationCode: this.currentPassage.translationCode,
                            bookCode: this.currentViewingBook.bibleBook.bookCode,
                            ignoreTranslation: this.notesIgnoreTranslation,
                        },
                    } :
                    {
                        params: {
                            page: page,
                            itemsPerPage: itemsPerPage,
                            translationCode: this.currentPassage.translationCode,
                            bookCode: this.currentPassage.bookCode,
                            chapterId: this.currentPassage.chapterId,
                            startVerseId: this.currentPassage.verseId,
                            endVerseId: this.currentPassage.endVerseId,
                            ignoreTranslation: this.notesIgnoreTranslation,
                        },
                    })
                .then(response => {
                    this.currentPageNotes = response.data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },

        async addNote() {
            if (!this.validateNote()) {
                this.showError = true;
                return;
            }

            this.selectedNote.userNoteReference = this.currentPassage;

            await DataFetch.post(this.baseUrl, this.selectedNote)
                .then(async () => {
                    this.clearSelected();
                    this.page = 1;
                    await this.getNotes(this.page, this.itemsPerPage);
                    this.showError = false;
                })
                .catch(() => {
                    this.showError = true;
                });
        },

        async updateNote() {
            if (this.selectedNote.labelText.length === 0 || this.selectedNote.noteText.length === 0) {
                this.showError = true;
                return;
            }

            await DataFetch.put(`${this.baseUrl}${this.selectedNote.noteId}`, this.selectedNote)
                .then(async () => {
                    this.clearSelected();
                    this.showError = false;
                })
                .catch(() => {
                    this.showError = true;
                });
        },

        async deleteNote(noteId) {
            let result = window.confirm('Are you sure you wish to delete this note?');
            if (!result) {
                return;
            }

            this.clearSelected();

            await DataFetch.remove(`${this.baseUrl}${noteId}`)
                .then(async () => {
                    this.page = 1;
                    await this.getNotes(this.page, this.itemsPerPage);
                    this.showError = false;
                })
                .catch(() => {
                    this.showError = true;
                });
        },
    };
};

export default call;